import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  categories: () => axios.get(`${API}/categories`).then((r) => r.data),
  transactions: (period) => axios.get(`${API}/transactions`, { params: { period } }).then((r) => r.data),
  pnl: (period) => axios.get(`${API}/pnl`, { params: { period } }).then((r) => r.data),
  periods: () => axios.get(`${API}/periods`).then((r) => r.data),
  trends: () => axios.get(`${API}/trends`).then((r) => r.data),
  duplicates: (period) => axios.get(`${API}/duplicates`, { params: { period } }).then((r) => r.data),
  company: () => axios.get(`${API}/company`).then((r) => r.data),
  setCompany: (name) => axios.put(`${API}/company`, { name }).then((r) => r.data),
  plaidStatus: () => axios.get(`${API}/plaid/status`).then((r) => r.data),
  plaidLinkToken: () => axios.post(`${API}/plaid/link-token`).then((r) => r.data),
  plaidExchange: (public_token) => axios.post(`${API}/plaid/exchange-token`, { public_token }).then((r) => r.data),
  plaidSync: () => axios.post(`${API}/plaid/sync`).then((r) => r.data),
  plaidDisconnect: () => axios.delete(`${API}/plaid/disconnect`).then((r) => r.data),
  upload: (formData, onProgress) =>
    axios
      .post(`${API}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: onProgress,
      })
      .then((r) => r.data),
  uploadCheck: (formData) =>
    axios
      .post(`${API}/upload/check`, formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data),
  previewUpload: (formData) =>
    axios
      .post(`${API}/upload/preview`, formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data),
  uploadMapped: (formData) =>
    axios
      .post(`${API}/upload/mapped`, formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data),
  addCategory: (payload) => axios.post(`${API}/categories`, payload).then((r) => r.data),
  deleteCategory: (name, kind) =>
    axios.delete(`${API}/categories`, { params: { name, kind } }).then((r) => r.data),
  create: (payload) => axios.post(`${API}/transactions`, payload).then((r) => r.data),
  update: (id, payload) => axios.put(`${API}/transactions/${id}`, payload).then((r) => r.data),
  recategorize: (period) => axios.post(`${API}/recategorize`, null, { params: { period } }).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/transactions/${id}`).then((r) => r.data),
  clearAll: (period) => axios.delete(`${API}/transactions`, { params: { period } }).then((r) => r.data),
  exportUrl: (period) => `${API}/export/excel${period ? `?period=${encodeURIComponent(period)}` : ""}`,
};

export const periodLabel = (p) => {
  if (!p) return "All periods";
  const [y, m] = p.split("-");
  const d = new Date(Number(y), Number(m) - 1, 1);
  return d.toLocaleString("en-US", { month: "long", year: "numeric" });
};

export const fmt = (n) =>
  new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
    Number(n || 0)
  );
